
/*
 * VNCcontact+ : A new level of contact management
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, OnInit, NgZone, OnDestroy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { BroadcastKeys } from "src/app/common/enums/broadcast.enum";
import { take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { Broadcaster } from "src/app/common/providers/broadcaster.service";
import { ConfigService } from "src/app/common/providers/config.service";
import { Subject } from "rxjs";
import { AppConstants } from "src/app/common/utils/app-constants";
import { CommonUtil } from "src/app/common/utils/common.utils";

@Component({
  selector: "vp-servicedesk-dialog",
  templateUrl: "./servicedesk-dialog.component.html"
})
export class ServicedeskDialogComponent implements OnInit, OnDestroy {

  serviceDeskURL: string;
  headerText: string = "VNC service desk ";
  buttonText: string = "Visit VNC service desk ";
  private isAlive$ = new Subject<boolean>();
  serviceDeskImage: String = CommonUtil.getFullUrl("/assets/img/vnc-service-desk.jpg");

  constructor(
    private broadcaster: Broadcaster,
    public dialogRef: MatDialogRef<ServicedeskDialogComponent>,
    private ngZone: NgZone,
    private configService: ConfigService,
    private translateService: TranslateService
  ) {
    this.broadcaster.on<any>(BroadcastKeys.HIDE_SERVICEDESK).pipe(take(1)).subscribe(res => {
      this.ngZone.run(() => {
        this.close();
      });
    });
    let browserLang = this.translateService.getBrowserLang();
    const localLang = localStorage.getItem(AppConstants.CONTACT_LANGUAGE);
    if (localLang !== null && localLang !== undefined && localLang !== "undefined") {
      browserLang = localLang;
    }
    browserLang = browserLang.match(/en|de/) ? browserLang : "en";
    if (this.configService.URLS.serviceDesk) {
      this.serviceDeskURL = this.configService.URLS.serviceDesk;
    } else {
      this.serviceDeskURL = "https://redmine.vnc.biz/helpdesk/incidents/new";
    }
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.isAlive$.next(false);
    this.isAlive$.unsubscribe();
  }

}
